import { CSSProperties } from 'react';

export const container: CSSProperties = {
  backgroundColor: '#E9B200',
  width: '100%',
};

export const body: CSSProperties = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  margin: 'auto',
  width: 360,
};

export const image1: CSSProperties = {
  width: 306,
};

export const aImage1: CSSProperties = {
  width: 108,
};